"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBirthdate = void 0;
function validateBirthdate(birthdate) {
    let splitBirthdate = birthdate.split("/");
    const day = splitBirthdate[0];
    const month = splitBirthdate[1];
    const year = splitBirthdate[2];
    let currentYear = new Date().getFullYear();
    if (!year || !day || !month) {
        return false;
    }
    if (day > 31 || day < 1) {
        return false;
    }
    if (month < 1 || month > 12) {
        return false;
    }
    if (year < 1900 || year > currentYear) {
        return false;
    }
    return true;
}
exports.validateBirthdate = validateBirthdate;
//# sourceMappingURL=validateBirthdate.js.map